import gql from "graphql-tag";

import universityFragment from "shared/University/fragments/universityFragment";

export const getRandomMentorsListCarouselQuery = gql`
    query RandomMentorListQuery(
        $universitySlug: String!
        $sequenceFilter: [MentorFilterInputField]
        $applyDegreeFilter: Boolean
        $offset: Int
        $limit: LimitedInt
        $domesticOrInternational: DomesticOrInternational
        $ubLang: String
    ) {
        university(slug: $universitySlug) {
            ...UniversityFull
            universityWidgetUrls: widgetUrls(selectedLocale: $ubLang) {
                url
            }
        }
        sequenceFilterMentorList(
            universitySlug: $universitySlug
            sequenceFilter: $sequenceFilter
            applyDegreeFilter: $applyDegreeFilter
            offset: $offset
            safeLimit: $limit
            domesticOrInternational: $domesticOrInternational
        ) {
            mentors {
                id
                profilePhoto(raw: true)
                firstName
                degree {
                    id
                    name
                }
                lastSeen
                degreeLevel
                country {
                    id
                    code
                }
                mentorFields {
                    primaryFlag {
                        code
                    }
                    secondaryFlag {
                        code
                    }
                }
                placeName
            }
        }
    }
    ${universityFragment}
`;
